module.exports = __webpack_public_path__ + "resources/img/zoom_rest_api_endpoint_options.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_rest_api_endpoint_options.png
// module id = 1271
// module chunks = 0